module.exports = __webpack_public_path__ + "img/NIA_LOGO.00162f1a.png";